const e = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptopS: 1024,
  laptopL: 1440,
  desktop: 2560
}, o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  screenSizes: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  e as a,
  o as s
};
